import { STORAGE_TYPE, getFromStorage } from '@Service/storageService';
import { defaultDigiApp } from '@Utils/commonUtils';

/* Clone json object */
export function jsonCopy(src) {
    return JSON.parse(JSON.stringify(src));
}

/* Compare function to sort the clause groups by their taxonomy */
export function sortByClauseCatTaxonomy(a, b) {
    if (a.clauseCategoryTaxonomy < b.clauseCategoryTaxonomy) {
        return -1;
    }
    if (a.clauseCategoryTaxonomy > b.clauseCategoryTaxonomy) {
        return 1;
    }
    return 0;
}

/* Compare function to sort the scorecard risk paragraph mapping data */
export function sortByRiskSeverity(a, b) {
    if (a.riskSeverityValue < b.riskSeverityValue) {
        return 1;
    }
    if (a.riskSeverityValue > b.riskSeverityValue) {
        return -1;
    }
    return 0;
}

/* Compare function to sort the scorecard risk paragraph mapping data */
export function sortByRiskSeverityDesc(a, b) {
    if (a.riskSeverity < b.riskSeverity) {
        return -1;
    }
    if (a.riskSeverity > b.riskSeverity) {
        return 1;
    }
    return 0;
}

/* Compare function to sort the labels by scoreValue */
export function sortByScoreValue(a, b) {
    if (a.scoreValue < b.scoreValue) {
        return -1;
    }
    if (a.scoreValue > b.scoreValue) {
        return 1;
    }
    return 0;
}

/* Compare function to sort the labels by startOffset */
export function sortByStartOffset(a, b) {
    if (a.startOffset < b.startOffset) {
        return -1;
    }
    if (a.startOffset > b.startOffset) {
        return 1;
    }
    return 0;
}

/* Compare function to sort the labels by sortByPriority */
export function sortByPriority(a, b) {
    if (a.priority < b.priority) {
        return -1;
    }
    if (a.priority > b.priority) {
        return 1;
    }
    return 0;
}

/* Flat DefaultClause Group */
export const flatDefaultGroup = (r, a) => {
    const b = {};

    /*  assign two field just for search purposes */
    if (a.clauses) {
        a.clauses.forEach(({ text = '', description = '' }) => {
            a = {
                ...a,
                textClause: `${a.textClause || ''} ${text}`,
                descClause: `${a.descClause || ''} ${description}`
            };
        });
    }

    Object.keys(a).forEach(k => {
        if (k !== 'groups' && k !== 'meta') b[k] = a[k];
    });

    r[b.id] = b;
    if (Array.isArray(a.groups)) {
        b.groups = a.groups.map(e => e.id);
        a.groups = a.groups.map(e => {
            let o = {};
            o = e;
            o.parent_id = a.id;
            o.clauseCategoryTaxonomy = a.clauseCategoryTaxonomy
                ? `${a.clauseCategoryTaxonomy} > ${e.name}`
                : `${a.name} > ${e.name}`;
            return o;
        });
        return a.groups.reduce(flatDefaultGroup, r);
    }
    return r;
};

export const prepareDigAppsList = (digApps = []) => {
    const digAppsList = {};

    const digAppName = getFromStorage('digAppName', STORAGE_TYPE.PROPERTY_BAG);

    digApps.sort((a, b) => a.name.localeCompare(b.name)).forEach(element => {
        digAppsList[element.name] = {
            id: element.id,
            text: element.name,
            description: element.description,
            selected: false,
            isFavorite: element.isFavorite,
            ...('totalActiveCount' in element ? { count: element.totalActiveCount } : {}),
            ...('scorecardRuleActiveCount' in element
                ? { count: element.scorecardRuleActiveCount }
                : {})
        };
    });

    // select digAppName from prop_bag if exists, else select the default digApp
    if (digAppName && Object.keys(digAppsList).includes(digAppName)) {
        digAppsList[digAppName].selected = true;
    } else {
        const selectedDigApp = defaultDigiApp(digAppsList);
        if (digAppsList[selectedDigApp]) digAppsList[selectedDigApp].selected = true;
    }

    return digAppsList;
};

export const scorecardsWithValidClauses = (scorecardList, flattenClauseGroups) =>
    scorecardList.map(s => {
        const validClause =
            s.suggestedClauseGroups &&
            s.suggestedClauseGroups.some(
                v => flattenClauseGroups[v.id] && flattenClauseGroups[v.id].clauses
            );

        if (validClause) {
            s.suggestedClauseGroupsMap = s.suggestedClauseGroups.reduce((arr, group) => {
                if (
                    typeof flattenClauseGroups[group.id] !== 'undefined' &&
                    flattenClauseGroups[group.id].clauses
                )
                    arr[group.id] = flattenClauseGroups[group.id];
                return arr;
            }, {});
        }

        return s;
    });
